import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_Responsive } from "../SlotGameType1_Responsive";
//

//namespace SlotGames {

export class CloverGirlGreen20Deluxe_Responsive extends SlotGameType1_Responsive {

    protected override helpFactory: IHelpFactory = new CloverGirlGreen20DeluxeHelpFactory();


    public override isDeluxGame: boolean = true;
    constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName: string = "CloverGirlGreen20Deluxe") {
        super(multigameParams, initData, gameName);

        this.spinnableReelsParams.topBorderWidth = 8;
        this.spinnableReelsParams.bottomBorderWidth = 8;
    }

    // protected PrepareFonts(resourceManager: ResourceManager): void {

    //     resourceManager.Add(new FontResource(this.basepath + "resources/Melting Letter.ttf", this.resid.ScopedResourceName(["BigSymbolFreeGames-font"])));

    // }

    //SEND COLOR FOR RSA 
    protected override color: RewardColor =
        {
            color: "#0A7CBF",
            coloroutherStroke: "black",
            colorinnerStroke: "#031333",
        }

}
class CloverGirlGreen20DeluxeHelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new CloverGirlGreen20DeluxeHelp(params);
    }
}

class CloverGirlGreen20DeluxeHelp extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(14, 38, 8),rgb(42, 89, 21), rgb(68, 140, 35),rgb(42, 89, 21),rgb(14, 38, 8)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

        return color;
    }
}


